var React = require('react');

function Next (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 19.2902V4.70985C3 3.94502 3.82366 3.46331 4.49026 3.83827L17.4505 11.1284C18.1302 11.5107 18.1302 12.4893 17.4505 12.8716L4.49026 20.1617C3.82366 20.5367 3 20.055 3 19.2902Z","fill":"currentColor","key":0}),React.createElement("rect",{"x":"17","y":"4","width":"4","height":"16","rx":"0.5","fill":"currentColor","key":1})]);
}

Next.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Next;

Next.default = Next;
